import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import TimerScheduleViewModel from "@/models/TimerScheduleViewModel";
export default function () {
    const add = async (
        timerSchedule: TimerScheduleViewModel
    ): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.post("/api/timerSchedule", timerSchedule)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const update = async (
        timerSchedule: TimerScheduleViewModel
    ): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.put(
                `/api/timerSchedule/${timerSchedule.attachedDeviceTypeId}`,
                timerSchedule
            )
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    const remove = async (AttachedDeviceTypeId: number): Promise<void> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.delete(`/api/timerSchedule/${AttachedDeviceTypeId}`)
                .then((result: AxiosResponse) => {
                    if (result.status === 200) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    const get = async (
        AttachedDeviceTypeId: number
    ): Promise<TimerScheduleViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get(`/api/timerSchedule/${AttachedDeviceTypeId}`)
                .then((result: AxiosResponse<TimerScheduleViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else if (result.status === 204) {
                        const timerSchedule = new TimerScheduleViewModel();
                        timerSchedule.attachedDeviceTypeId =
                            AttachedDeviceTypeId;
                        add(timerSchedule);
                        resolve(timerSchedule);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };
    return {
        add,
        update,
        remove,
        get,
    };
}
